import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Documents from "./sharepoint/Documents";
import { getContact } from "./services/soar";

function NonClient(props) {
  const navigate = useNavigate();
  const params = useParams();
  const contactId = params.contactId;
  const [data, setData] = useState({});

  useEffect(() => {
    getContactData();
  }, []);

  const getContactData = async () => {
    const response = await getContact(contactId);
    console.log("Response", response);
    setData(response);
  };

  return (
    <div>
      {data[0] && (
        <div className="h4 mb-4">
          {data[0].fullname}
          <i
            className="fas fa-pencil text-primary ms-2"
            onClick={() => {
              navigate(`/contact/${contactId}`);
            }}
            role="button"
          />
        </div>
      )}
      {data[0]?.owningbusinessunit && (
        <div>
          <div className="h5">Documents</div>
          <div className="rounded border border-dark bg-light p-2 pb-4">
            <Documents
              id={contactId}
              type="ClientID"
              state={data[0].owningbusinessunit["@name"].replaceAll(
                "SAFY of ",
                ""
              )}
              puconfig={{}}
            />
          </div>
        </div>
      )}
    </div>
  );
}

export default NonClient;
